<script>
  import { business, loading, showPopup } from "../stores.js";
  import { pop } from "svelte-spa-router";
  import * as BusinessDAL from "../dal/business-dal";
  import * as UserDAL from "../dal/user-dal";
  import clone from "just-clone";

  let list = [];
  let outOfStock;

  business.subscribe((b) => {
    if (!b) return;
    getList();
    outOfStock = clone(b.outOfStock);
  });

  function getList() {
    let map = {};
    for (const section of $business.menu) {
      for (const item of section.items) {
        for (const optionsSection of item.options) {
          for (const option of optionsSection.items) {
            map[option.label] = true;
          }
        }
        for (const checkboxSection of item.checkboxes) {
          for (const checkbox of checkboxSection.items) {
            map[checkbox.label] = true;
          }
        }
      }
    }
    list = Object.keys(map);
    list.sort((a, b) => a.localeCompare(b));
  }

  function addRemove(label) {
    let idx = outOfStock.indexOf(label);
    if (idx != -1) {
      outOfStock.splice(idx, 1);
    } else {
      outOfStock.push(label);
    }
    outOfStock = outOfStock;
  }

  async function save() {
    try {
      $loading = true;
      await BusinessDAL.setOutOfStock($business.code, outOfStock);
      $loading = false;
      pop();
    } catch (e) {
      $loading = false;
      UserDAL.sendLog("setOutOfStock", e.toString());
      showPopup("משהו השתבש", () => {});
    }
  }

</script>

<div class="overlay" on:click={pop}>
  <div class="container">
    <div class="bg" on:click|stopPropagation>
      <div class="title">עריכת מלאי</div>
      <div class="list">
        {#each list as label}
          <div
            class="item"
            on:click={() => {
              addRemove(label);
            }}
          >
            <div class="onOff" class:off={outOfStock.includes(label)}>
              <div class="switch" class:off={outOfStock.includes(label)} />
            </div>
            {label}
          </div>
        {/each}
      </div>
      <div class="btns">
        <div class="save" on:click={save}>שמירה</div>
      </div>
    </div>
  </div>
</div>

<style>
  .onOff {
    width: 40px;
    height: 20px;
    border: 4px solid var(--green1);
    border-radius: 100px;
    margin-left: 10px;
    background: var(--green1);
    position: relative;
    transition: all 0.25s ease-out;
  }

  .onOff.off {
    background: var(--red1);
    border: 4px solid var(--red1);
  }

  .switch {
    width: 20px;
    height: 20px;
    border-radius: 100px;
    background: white;
    position: absolute;
    left: 0;
    transform: translateX(0%);
    transition: all 0.15s ease-out;
  }

  .switch.off {
    left: 100%;
    transform: translateX(-100%);
  }

  .item {
    display: flex;
    align-items: center;
    margin: 14px;
    font-size: 16px;
  }

  .overlay {
    position: fixed;
    background: #0004;
    width: 100%;
    height: 100%;
    padding: 10px;
    box-sizing: border-box;
    z-index: 2;
    display: block;
    justify-content: center;
    padding-top: var(--nav-bar-height);
    margin-bottom: 30px;
    top: 0;
    overflow: auto;
  }

  .container {
    margin-top: 30px;
    margin-bottom: 30px;
  }

  .bg {
    width: 100%;
    max-width: 560px;
    background: white;
    direction: rtl;
    padding: 18px;
    border-radius: 3px;
    box-shadow: 0 20px 25px -20px;
    box-sizing: border-box;
    margin-left: auto;
    margin-right: auto;
  }

  .title {
    font-size: 20px;
    margin: 20px;
  }

  .list {
    margin-right: 30px;
  }

  .save {
    width: 100%;
    background: var(--green1);
    color: white;
    max-width: 300px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    font-size: 20px;
    padding: 10px;
    margin-top: 40px;
    border-radius: 3px;
    cursor: pointer;
  }
  @media screen and (max-width: 560px) {
    .overlay {
      padding: 0;
      padding-top: 30px;
    }
  }

</style>
